import { createAction, props } from '@ngrx/store'

export const getNextAvailablePaddleNumber = createAction(
  '[BasePaddleNumbers/API] Get Next Available Paddle Number',
  props<{
    onSuccess: (paddleNumber: string) => void
  }>(),
)

export const getNextAvailablePaddleNumberDone = createAction(
  '[BasePaddleNumbers/API] Get Next Available Paddle Number Done',
)

export const checkPaddleNumberAvailability = createAction(
  '[BasePaddleNumbers] Check Paddle Number Availability',
  props<{ paddleNumber: string; onResponse: (available: boolean) => void }>(),
)
export const checkPaddleNumberAvailabilityCheckDone = createAction(
  '[BasePaddleNumbers/API] Paddle Number Available Check Done',
)
